import "./migration.scss";

const NEW_SPACE_URL =
  "https://app.hokios.com/voyancequalite/auth/login";

function MigrationPage() {
  return (
    <main className="migration-page">
      <div className="migration-page__glow migration-page__glow--top" />
      <div className="migration-page__glow migration-page__glow--bottom" />

      <section className="migration-card" aria-labelledby="migration-title">
        <div className="migration-card__brand" aria-label="Voyance Qualité">
          <span className="migration-card__brand-mark" aria-hidden="true">
            <svg viewBox="0 0 32 32" role="img">
              <path d="M16 2.5c.8 7.8 5.7 12.7 13.5 13.5C21.7 16.8 16.8 21.7 16 29.5 15.2 21.7 10.3 16.8 2.5 16 10.3 15.2 15.2 10.3 16 2.5Z" />
              <circle cx="25.5" cy="6.5" r="2.5" />
            </svg>
          </span>
          <span>Voyance Qualité</span>
        </div>

        <div className="migration-card__badge">
          <span aria-hidden="true" />
          Une nouvelle expérience
        </div>

        <h1 id="migration-title">
          Voyance Qualité <strong>évolue</strong>
        </h1>

        <p className="migration-card__intro">
          Votre espace fait peau neuve pour vous offrir une expérience plus
          simple, plus fluide et plus moderne.
        </p>

        <a className="migration-card__button" href={NEW_SPACE_URL}>
          Accéder au nouvel espace
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </a>

        <p className="migration-card__hint">
          Vous allez être redirigé vers notre nouvelle plateforme sécurisée.
        </p>
      </section>

      <p className="migration-page__footer">
        © {new Date().getFullYear()} Voyance Qualité
      </p>
    </main>
  );
}

export default MigrationPage;
